import React, { useState } from "react";
import { Button, Input, Modal } from "semantic-ui-react";

type ConfirmationModalProps = {
  readonly prefixContent: string;
  readonly expectedText?: string;
  readonly onConfirm: () => void;
  readonly trigger: React.ReactNode;
  readonly message: React.ReactNode;
};

export default function ConfirmationModal(props: ConfirmationModalProps) {
  const { prefixContent, onConfirm, expectedText, trigger, message } = props;
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");

  const invalidInput = text !== expectedText;
  const tryConfirm = () => {
    if (text === expectedText) {
      setOpen(false);
      setText("");
      onConfirm();
    }
  };

  const closeModal = () => {
    setText("");
    setOpen(false);
  };

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  return (
    <Modal
      className="dark"
      size="tiny"
      open={open}
      onClose={closeModal}
      onOpen={() => setOpen(true)}
      trigger={trigger}
      onClick={stopPropagation}
      onDoubleClick={stopPropagation}
    >
      <Modal.Header>{prefixContent}</Modal.Header>
      <Modal.Content>
        {message}
        <Input
          autoFocus
          style={{ width: "100%" }}
          value={text}
          onPaste={(e) => {
            e.preventDefault();
          }}
          onChange={(_e, d) => setText(d.value)}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button id="cancel_button" secondary onClick={closeModal}>
          Cancel
        </Button>
        <Button
          id="confirm_button"
          primary
          disabled={invalidInput}
          onClick={tryConfirm}
        >
          Confirm
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
